import React from "react";
import { useHistory } from "react-router-dom";
import Text from "../../../_components/Text";
import Button from "../../../_components/Button";

import Page from "../../../_components/Layout/Page";
import Row from "../../../_components/Layout/Row";
import Column from "../../../_components/Layout/Column";

export default (props) => {
  const history = useHistory();
  function go(href) {
    history.push(href);
  }
  return (
    <Page>
      <Row>
        <Column col="12" className="mb-3">
          <Text fontSize="md" color="primary">
            Detalhes da empresa
          </Text>
          <Button onClick={() => go("/settings/branch")} as="text">
            <Text color="secondary">Acessar configurações</Text>
          </Button>
          <hr />
        </Column>
        <Column col="12">
          <Text fontSize="md" color="primary">
            Planos e faturas
          </Text>
          <div>
            <Button className="my-3" onClick={() => go("/plans")} as="text">
              <Text color="secondary">Visualizar a Assinatura</Text>
            </Button>
            <div>
              <Button onClick={() => go("/plan/branch-invoices")} as="text">
                <Text color="secondary">Visualizar Faturas</Text>
              </Button>
            </div>
          </div>
          <hr />
        </Column>
        <Column col="12">
          <Text fontSize="md" color="primary">
            Configurações de vendas
          </Text>
          <div>
            <Button
              className="my-3"
              onClick={() => go("/settings/sales")}
              as="text"
            >
              <Text color="secondary">Acessar Configurações de vendas</Text>
            </Button>
          </div>
          <hr />
        </Column>
      </Row>
    </Page>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Settings/index.jsx